module.exports = __webpack_public_path__ + "static/media/Prev-alt.fc20c9db.svg";